import common from "../js/common";
import store from '../store/index.js'

const common_tb = {};

common_tb.tb_host = 'https://api.wapg.cn/taobao';

//选品列表(https://api.wapg.cn/taobao/getTaoShopApi)
common_tb.get_select_goods = common_tb.tb_host + '/getTaoShopApi';
common_tb.get_select_goods_by_json = common_tb.tb_host + '/getTaoShopApiJson';
//商品详情接口(https://api.wapg.cn/taobao/getTbkScPublisherInfoGetRequest)
common_tb.get_sku_detail_data = common_tb.tb_host + '/getTbkScPublisherInfoGetRequest';
//订单列表(https://api.wapg.cn/taobao/orderListAll)
common_tb.get_order_list = common_tb.tb_host + '/orderListAll';
//订单详情接口地址(完成时间)(https://api.wapg.cn/taobao/orderByFinish)
common_tb.get_order_by_Finish = common_tb.tb_host + '/orderByFinish';
//淘口令接口(https://api.wapg.cn/taobao/getTaotpwd)
common_tb.get_tb_command = common_tb.tb_host + '/getTaotpwd';
//淘宝授权接口（https://oauth.taobao.com/authorize?response_type=code&client_id=28396368&redirect_uri=http://api.wapg.cn/taobao/getcode&state=1212&view=web
common_tb.get_oauth_url = 'https://oauth.taobao.com/authorize?response_type=code&client_id=28396368&redirect_uri=http://api.wapg.cn/taobao/getcode&view=wap';
//收入统计
common_tb.order_count_new = common_tb.tb_host + '/orderCountNew';
//指定日期预估收入列表
common_tb.get_everyday_count_list = common_tb.tb_host + '/DayCount';
//群下级人数及对应收入
common_tb.level_count_data = common_tb.tb_host + '/LeveCountData';
//一个代理的下级、下下级代理给当前代理所带来的预估提成佣金
common_tb.pid_level_count_list = common_tb.tb_host + '/PidLevelCountListNew';
//用户可提款金额接口
common_tb.user_pay_to = common_tb.tb_host + '/UserPayTo';
//用户提款明细接口：
common_tb.user_pay_list = common_tb.tb_host + '/UserPayLists';
//获取提款纪录
common_tb.get_order_by_sumbit = common_tb.tb_host + "/orderBySubmit";
//订单详情下载xls
common_tb.get_order_by_finish_xls = common_tb.tb_host + "/orderByFinishXls";
//用户提现接口
common_tb.user_submit = common_tb.tb_host + '/userSubmit';
//系统配置接口
common_tb.sub_config = common_tb.tb_host + '/SubConfig';
//获取饿了么数据
common_tb.get_eleme_data = common_tb.tb_host + '/getELeM';





//=====================类似全局变量=========================
common_tb.back_from_count_new = false;
//提款操作来自于淘宝的数据页面
common_tb.pay_from_tb_data_page = false;
//详情页面是否展示中
common_tb.is_show_tb_sku_detail = false;
//预估佣金 私有比例
common_tb.commissionRate_pir = 0.55 ;



common_tb.getTaobaoPid = function(){
    if (common.isClient_whole()) {
        return store.state.channel_tb_pid;
    }else{
        if(store.state.taobao_pid && store.state.taobao_pid !== 'undefined'){
            return store.state.taobao_pid;
        }else{
            return '';
        }
    }
}



export default common_tb;
